import { useFormikContext } from "formik";
import React, { CSSProperties, useEffect, useRef, useState } from "react";
import { FC } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import { autocompleteDTO } from "./autocompleteDTO";
import Tooltip from '@mui/material/Tooltip';

const TypeHeadInout: FC<typeHeadInoutProps> = (props) => {
  const { values, setFieldValue } = useFormikContext<any>();
  const ref = useRef<any>(null);
  const [singleSelections, setSingleSelections] = useState<any>(values[props.campo] || []);
  const [deleteOptions, setDeleteOptions] = useState<boolean>(false)

  // Sincronizar a Formik en cuanto el usuario cambia la selección (sin flushSync para no provocar bucles en otros steps).
  const handleChange = (selections: any) => {
    setSingleSelections(selections);
    setFieldValue(props.campo, selections);
  };

  useEffect(() => {
    if (values[props.campo] === undefined) {
      setFieldValue(props.campo, []);
    }
  }, [])

  // Sincronizar cuando el padre actualiza el valor (ej. al abrir editar receta fija).
  // Usar valor serializado en la dependencia evita bucle por referencia nueva en cada render de Formik.
  const valueFromFormik = values[props.campo];
  const valueKey = Array.isArray(valueFromFormik)
    ? JSON.stringify(valueFromFormik.map((e: any) => e?.value ?? e))
    : String(valueFromFormik ?? '');
  useEffect(() => {
    const value = valueFromFormik;
    if (value && Array.isArray(value) && value.length > 0) {
      if (value[0]?.text !== "" && value[0]?.text !== undefined) {
        setSingleSelections(value);
        setDeleteOptions(true);
      }
    } else if (value !== "" && value !== undefined && !Array.isArray(value)) {
      setSingleSelections(value);
      setDeleteOptions(true);
    } else if (value === undefined || (Array.isArray(value) && value.length === 0)) {
      setSingleSelections([]);
    }
    // Notificar al padre solo cuando hay una selección real (no en montaje inicial vacío).
    // Así la sección de crear contrato carga bien y el modal se abre al seleccionar contrato origen/destino.
    const hasSelection = value && (Array.isArray(value) ? value.length > 0 : value !== '');
    if (props.onChange && hasSelection) props.onChange(ref);
  }, [valueKey, props.campo])
  try {
    const style: CSSProperties = {
      ...props.style,
      margin: '0px'
    }
    return (
      <div className={'content-form position-relative w-100'}>
        {props.label ? (
          <label htmlFor={props.campo} className='d-flex align-items-center form-label fw-b'>
            {props.label}
          </label>
        ) : null}
        <Typeahead
          ref={ref}
          style={style}
          id={props.advanceOptions?.id}
          className={props.clase}
          placeholder={props.advanceOptions?.placeholder}
          multiple={props.advanceOptions?.multiple || false}
          disabled={props.disabled}
          onChange={handleChange}
          onInputChange={props.onChange}
          onBlur={() => {
            if (ref.current === null) {
              return
            }
            if (ref.current.state.selected.length === 0) {
              ref.current.clear()
            }
          }}
          onFocus={(selected: any) => {
            if (ref.current === null)
              return
            if (selected.target.value === '') {
              ref.current.state.selected = []
            }
          }}
          selected={singleSelections}
          labelKey={(item: any) => item.text}
          options={props.advanceOptions?.options.sort() || []}
          filterBy={props.advanceOptions?.filterBY || ['text']}
          flip={props.advanceOptions?.flip || false}
          renderMenuItemChildren={(options: any) => {
            return (
              <>
                {options.imgUrl ? (
                  <img
                    style={{ width: '70px', marginRight: '10px' }}
                    alt='img items'
                    src={options.imgUrl}
                  />
                ) : null}
                <Tooltip title={<h4 style={{ color: '#fff' }}>{options.text}</h4>} arrow>
                  <span>{options.text}</span>
                </Tooltip>
              </>
            )
          }}
        />
        {deleteOptions && !props.disabled ? (
          <span
            className='clear-input position-absolute me-2'
            onClick={() => {
              if (ref.current?.state?.selected?.length > 0) {
                setFieldValue(props.campo, [{ text: '', value: '' }])
                ref.current._handleClear()
              }
            }}
          >
            X
          </span>
        ) : (
          <span
            className='arrow-container'
            onClick={() => ref.current?.focus()}
          >
            <i className='bi bi-chevron-down arrow-select'></i>
          </span>
        )}
      </div>
    )
  } catch (err) {
    return <></>
  }
}
export interface typeHeadInoutProps {
  columnInput?: string,
  label?: string,
  campo: string,
  advanceOptions?: autocompleteDTO,
  clase?: string,
  id?: string,
  placeholder?: string,
  style?: React.CSSProperties,
  disabled?: boolean,
  onChange?(item: any): void,
}
export { TypeHeadInout }